import { motion } from 'motion/react';
import { Skeleton } from './Skeleton';

export function LayoutSkeleton() {
  return (
    <motion.div
      className="min-h-screen bg-background flex"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {/* Sidebar skeleton */}
      <aside className="hidden lg:flex w-64 border-r border-border bg-surface flex-col">
        {/* Logo */}
        <div className="h-16 flex items-center px-4 border-b border-border">
          <Skeleton className="w-8 h-8 rounded" />
          <Skeleton className="w-20 h-5 ml-2" />
        </div>

        {/* Nav items */}
        <nav className="p-4 space-y-2">
          <Skeleton className="h-10 w-full rounded-lg" />
          <Skeleton className="h-10 w-full rounded-lg" />
          <Skeleton className="h-10 w-full rounded-lg" />
        </nav>

        {/* Bandmates section */}
        <div className="px-4 pt-4">
          <Skeleton className="w-24 h-3 mb-3" />
          <div className="space-y-2.5">
            {[0, 1, 2].map((i) => (
              <div key={i} className="flex items-center gap-2.5">
                <Skeleton className="w-7 h-7 rounded-full" />
                <Skeleton className="w-20 h-3.5" />
              </div>
            ))}
          </div>
        </div>

        {/* Storage */}
        <div className="mt-auto p-4 border-t border-border">
          <Skeleton className="w-16 h-3 mb-2" />
          <Skeleton className="w-full h-2 rounded-full" />
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col">
        {/* Header skeleton */}
        <header className="h-16 border-b border-border bg-surface/95 flex items-center justify-between px-4">
          <div />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-24 rounded-lg" />
            <Skeleton className="w-8 h-8 rounded-full" />
            <Skeleton className="w-8 h-8 rounded-full" />
          </div>
        </header>

        {/* Content skeleton */}
        <main className="flex-1 p-4 md:p-6 lg:p-8 space-y-6">
          {/* Welcome */}
          <div>
            <Skeleton className="w-64 h-8 mb-2" />
            <Skeleton className="w-48 h-4" />
            <div className="flex gap-2 mt-3">
              <Skeleton className="w-24 h-8 rounded-full" />
              <Skeleton className="w-20 h-8 rounded-full" />
              <Skeleton className="w-20 h-8 rounded-full" />
            </div>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[0, 1, 2].map((i) => (
              <div key={i} className="rounded-xl border bg-card p-4 space-y-3">
                <Skeleton className="w-full aspect-video rounded-lg" />
                <Skeleton className="w-3/4 h-4" />
                <Skeleton className="w-1/2 h-3" />
              </div>
            ))}
          </div>
        </main>

        {/* Footer */}
        <footer className="border-t border-border bg-surface px-4 py-3">
          <Skeleton className="w-48 h-3" />
        </footer>
      </div>
    </motion.div>
  );
}